import React, { useState } from 'react';

const notFound = () => {
	return (
		<>
			<h2>Page Not Found in app.</h2>
			
		</>
	);
}

export default notFound;

